import React from 'react';
import { useNavigate } from 'react-router-dom';

import { MdOutlineClear } from 'react-icons/md';

import { IoMdAdd } from 'react-icons/io'

const FilterComponent = ({ filterText, onFilter, onClear, create }) => {

    const navigate = useNavigate();

    return (
        <div>
            <div className="input-group">
                <input
                    id="search"
                    type="text"
                    className="form-control"
                    placeholder="Buscar..."
                    value={filterText}
                    aria-label="Recipient's username"
                    aria-describedby="button-addon2"
                    onChange={onFilter}
                />
                <button
                    onClick={onClear}
                    className="btn btn-warning"
                    type="button"
                    id="button-addon2"
                ><MdOutlineClear /></button>
                {create !== '' && <button
                    onClick={() => navigate(create)}
                    className="btn btn-primary"
                    type="button"
                    id="button-addon2"
                ><IoMdAdd /></button>}
            </div>
        </div>
    )
};

export default FilterComponent;